// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getAdvertiserListFailed, getAdvertiserListRequested, getAdvertiserListSucceeded } from './select-advertiser.actions';
import { DictionariesService } from '@par/app/core/data-services/dictionaries.service';
import { Store } from '@ngrx/store';
import { selectAdvertiserListResponse } from './select-advertiser.selectors';

@Injectable()
export class SelectAdvertiserEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAdvertiserListRequested),
      withLatestFrom(this.store.select(selectAdvertiserListResponse)),
      filter(([, response]) => response == null),
      switchMap(() => this.service.getAdvertiserList()
        .pipe(
          map((response) => getAdvertiserListSucceeded({response})),
          catchError(() => of(getAdvertiserListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: DictionariesService,
    private store: Store,
  ) {
  }
}
